module.exports = __webpack_public_path__ + "static/media/1.question.ff1cb7ab.mp4";